import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1B42A4BC-3B55-4C21-BDEF-94DC970012F9
 * name view-stream
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-stream.svg
 * tags
 * - View 
 */
export const ViewStreamIcon = createSvgIcon(<><path d="M4,5V11H21V5M4,18H21V12H4V18Z" /></>, 'ViewStreamIcon');
export default ViewStreamIcon